import src from "IMAGE";
export default { src, width: 380, height: 80, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAgYHSgUO0RVAA0UIQAEBgkADhYsABEaNgANFCkAAgMGAAktO3EUPkpoARYhOAAIDRQAERoyARgkSwEWIkgAEhw72nkG9zbIELQAAAAASUVORK5CYII="};
